import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
import { HeadData } from './types';

export const initializeHead = createAction(`${reduxKey}.INIT_HEAD`, (head: HeadData) => ({ head }));
